/**
 * Image Assets
 *
 * Centralized image path constants.
 * All image references should use these constants.
 */

/**
 * Logo and branding images
 */
export const LOGO_SVG = '/Frame.svg'
export const LOGO_PNG = '/Frame.png'

/**
 * Icon images
 */
export const SEARCH_ICON = '/Icon.png'
export const VIEW_ZONES_ICON = '/Icon (1).png'
export const ACTIVE_ZONES_ICON = '/Icon (1).png'

/**
 * Map images
 */
export const CARIBBEAN_MAP_BLANK = '/Caribbean_map_blank 1.png'
